import {Component, EventEmitter, Input, Output} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HowToPersonaliseContentModalComponent } from '../how-to-personalise-content-modal/how-to-personalise-content-modal.component';
import {ConstantsService} from "../../services/constants/constants.service";

@Component({
  selector: 'app-opt-in-question',
  templateUrl: './opt-in-question.component.pug',
  styleUrls: ['./opt-in-question.component.scss'],
  standalone: false
})
export class OptInQuestionComponent {
  defaultOptInQuestion = ConstantsService.DEFAULT_OPT_IN_QUESTION

  @Input() isOptInQuestionEnabled: boolean = true;
  @Output() isOptInQuestionEnabledChange = new EventEmitter<boolean>();

  @Input() optInQuestion: string = this.defaultOptInQuestion;
  @Output() optInQuestionChange = new EventEmitter<string>();

  @Input() questionnaireId:string = ''
  @Input() configureOptInOnly: boolean = false;
  @Input() isEditTitle: boolean = false;
  @Input() questionnaireTitle:string = ''
  @Input() selectedRefType:any
  @Input() max_questions_limit = 5;

  constructor(
    public _bsModalRef: BsModalRef,
    public modalService: BsModalService,
  ) {
  }

  setDefaultQuestion(): void {
    this.optInQuestion = this.defaultOptInQuestion;
    this.optInQuestionChange.emit(this.optInQuestion);
  }

  toggleOptInQuestionEnabled(): void {
    this.isOptInQuestionEnabled = !this.isOptInQuestionEnabled;
    this.isOptInQuestionEnabledChange.emit(this.isOptInQuestionEnabled);

  }

  onOptInQuestionChange(value: string): void {
    this.optInQuestion = value;
    this.optInQuestionChange.emit(value);
}

  showHowtoPersonaliseContentModal(): void {
    this._bsModalRef.hide();
    const initialState = {
      'questionnaireId': this.questionnaireId,
      'questionnaireTitle': this.questionnaireTitle,
      'isEditTitle': this.isEditTitle,
      'configureOptInOnly': this.configureOptInOnly,
      'selectedRefType': this.selectedRefType,
      'max_questions_limit': this.max_questions_limit,
      'isOptInQuestionEnabled': this.isOptInQuestionEnabled,
      'optInQuestion': this.optInQuestion
    };
    this.modalService.show(
        HowToPersonaliseContentModalComponent, {class: 'modal-dialog-centered xl-popup', initialState}
    );
  }
}
